export class CheckupDetails {
    doctor: string;
    created_at: Date;
    edited_at: Date;
    title: string;
    remarks: string;
    extraNotes: string;
    description: string;
    category: string;
    arrayDescription: any;
}
